var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanificationParution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6,16.8V8.2H4.4v8.6H14.6 M14.6,6.5c0.9,0,1.7,0.8,1.7,1.7v8.6c0,0.9-0.8,1.7-1.7,1.7H4.4c-1,0-1.7-0.8-1.7-1.7V8.2 c0-1,0.8-1.7,1.7-1.7h0.9V4.8c0-2.4,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3v1.7H14.6 M9.5,2.2c-1.4,0-2.6,1.2-2.6,2.6v1.7h5.1V4.8 C12.1,3.4,10.9,2.2,9.5,2.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.9,8.6L9.9,8.6v0.8c1.7,0.2,2.9,1.7,2.7,3.4c-0.2,1.4-1.3,2.5-2.7,2.7v0.8c2.1-0.2,3.6-2.1,3.4-4.2 C13.1,10.2,11.7,8.8,9.9,8.6 M9.1,8.6C8.4,8.7,7.7,9,7.1,9.5l0.5,0.6C8,9.7,8.6,9.5,9.1,9.4V8.6 M6.5,10c-0.5,0.6-0.8,1.3-0.8,2 h0.8c0.1-0.5,0.3-1.1,0.6-1.5L6.5,10 M5.7,12.8c0.1,0.7,0.4,1.5,0.8,2l0.5-0.5c-0.3-0.4-0.6-0.9-0.6-1.5H5.7 M7.6,14.9l-0.5,0.5 c0.6,0.5,1.3,0.8,2,0.9v-0.8C8.6,15.4,8,15.2,7.6,14.9 M9.7,10.5v2l1.7,1L11.1,14l-2-1.2v-2.3H9.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanificationParution);
export default __webpack_public_path__ + "static/media/planification_parution.e577e4d9.svg";
export { ForwardRef as ReactComponent };